import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { TrashListCallbackStoreContract } from '../interfaces';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterTrashListCallBack extends Callback<Array<FilterUsers>> {
	public constructor(private readonly store: TrashListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setFilterUsers(successResponse);
	};
}
